module.exports = __webpack_public_path__ + "media/fresh/male-student-chair@2x-6dcac8e6.png";